"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerBehavior = exports.BumperBehavior = exports.ScrollAlignment = exports.Axis = void 0;
var Axis;
(function (Axis) {
    Axis["Horizontal"] = "horizontal";
    Axis["Vertical"] = "vertical";
})(Axis || (exports.Axis = Axis = {}));
var ScrollAlignment;
(function (ScrollAlignment) {
    /** @member {string} */
    /** Aligns the off-screen element to the start of the scrollable, within bounds of its scroll offsets */
    ScrollAlignment["AlignToStart"] = "alignToStart";
    /** @member {string} */
    /** Aligns the off-screen element all the way to the opposite site from where it was out of view. */
    ScrollAlignment["AlignToFarEnd"] = "alignToFarEnd";
    /** @member {string} */
    /** Aligns the off-screen element to the center of its scroll offsets, if possible. */
    ScrollAlignment["AlignToCenter"] = "alignToCenter";
    /** @member {string} */
    /** Aligns the off-screen element just into view. */
    ScrollAlignment["AlignToNext"] = "alignToNext";
})(ScrollAlignment || (exports.ScrollAlignment = ScrollAlignment = {}));
var BumperBehavior;
(function (BumperBehavior) {
    /** @member {string} */
    /** Bumper presses result in no action from the library. */
    BumperBehavior["None"] = "none";
    /** @member {string} */
    /** Bumper presses will scroll horizontally  */
    BumperBehavior["Scroll"] = "scroll";
})(BumperBehavior || (exports.BumperBehavior = BumperBehavior = {}));
var TriggerBehavior;
(function (TriggerBehavior) {
    /** @member {string} */
    /** Trigger presses only fire callbacks to the parent scrollables */
    TriggerBehavior["None"] = "none";
    /** @member {string} */
    /** Trigger presses fire callbacks to the parent scrollable and will scroll vertically,
     * focusing on the element that would provide the most opposite to the direction scrolled
     */
    TriggerBehavior["Scroll"] = "scroll";
    /** @member {string} */
    /** Trigger presses fire callbacks to the parent scrollable and will scroll vertically and between groups */
    TriggerBehavior["SnapToGroups"] = "snapToGroups";
})(TriggerBehavior || (exports.TriggerBehavior = TriggerBehavior = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2Nyb2xsYWJsZU9wdGlvbnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdHlwZXMvc2Nyb2xsYWJsZU9wdGlvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDREQUE0RDs7O0FBRTVELElBQVksSUFHWDtBQUhELFdBQVksSUFBSTtJQUNaLGlDQUF5QixDQUFBO0lBQ3pCLDZCQUFxQixDQUFBO0FBQ3pCLENBQUMsRUFIVyxJQUFJLG9CQUFKLElBQUksUUFHZjtBQUVELElBQVksZUFhWDtBQWJELFdBQVksZUFBZTtJQUN2Qix1QkFBdUI7SUFDdkIsd0dBQXdHO0lBQ3hHLGdEQUE2QixDQUFBO0lBQzdCLHVCQUF1QjtJQUN2QixvR0FBb0c7SUFDcEcsa0RBQStCLENBQUE7SUFDL0IsdUJBQXVCO0lBQ3ZCLHNGQUFzRjtJQUN0RixrREFBK0IsQ0FBQTtJQUMvQix1QkFBdUI7SUFDdkIsb0RBQW9EO0lBQ3BELDhDQUEyQixDQUFBO0FBQy9CLENBQUMsRUFiVyxlQUFlLCtCQUFmLGVBQWUsUUFhMUI7QUFFRCxJQUFZLGNBT1g7QUFQRCxXQUFZLGNBQWM7SUFDdEIsdUJBQXVCO0lBQ3ZCLDJEQUEyRDtJQUMzRCwrQkFBYSxDQUFBO0lBQ2IsdUJBQXVCO0lBQ3ZCLCtDQUErQztJQUMvQyxtQ0FBaUIsQ0FBQTtBQUNyQixDQUFDLEVBUFcsY0FBYyw4QkFBZCxjQUFjLFFBT3pCO0FBRUQsSUFBWSxlQVlYO0FBWkQsV0FBWSxlQUFlO0lBQ3ZCLHVCQUF1QjtJQUN2QixvRUFBb0U7SUFDcEUsZ0NBQWEsQ0FBQTtJQUNiLHVCQUF1QjtJQUN2Qjs7T0FFRztJQUNILG9DQUFpQixDQUFBO0lBQ2pCLHVCQUF1QjtJQUN2Qiw0R0FBNEc7SUFDNUcsZ0RBQTZCLENBQUE7QUFDakMsQ0FBQyxFQVpXLGVBQWUsK0JBQWYsZUFBZSxRQVkxQiJ9